import React from 'react'
import { P } from '../../../Styles/style'

const FooterPara = () => {
    return (
        <div><P>Copyright © 2023 ARBKONG. All Right Reserved</P></div>
    )
}

export default FooterPara